/*
 * @Author: your name
 * @Date: 2022-02-07 15:23:26
 * @LastEditTime: 2025-02-10 17:55:03
 * @LastEditors: kevinqq 350910378@qq.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \baishu_react_ui\src\components\BsySelectCheckBox\index.jsx
 */
import React, { Component } from "react";
import { BsyConfig } from "../../global/BsyConfig";

import { BsyUtils } from "../../utils/Utils";
import BsySelect from "../BsySelect";
import "./index.css";

class BsyUserCheck extends BsySelect {
  userValueMap = {};

  constructor(props) {
    super({
      hasSelectAll: !0,
      hasSelectEmpty: !0,
      emptySelectText: React.language("unfilled"),
      ...props,
    });

    this.loadUserMap(this.state.value);
  }

  UNSAFE_componentWillReceiveProps(nextProps, nextContext) {
    if (this.state.value !== nextProps.value) {
      this.setState(
        {
          value: nextProps.value,
        },
        () => {
          this.loadUserMap(this.state.value);
        }
      );
    }
  }

  loadUserMap = (value) => {
    let that = this;
    let c = [];
    that.userValueMap["anonymous"] = React.language("widget.user.anonymous");
    that.userValueMap["100000000000000000000001"] = React.language(
      "widget.user.current"
    );
    that.userValueMap["fx_param_empty"] = this.options.emptySelectText;
    that.userValueMap[this.state.value] || c.push(this.state.value);
    if (!BsyUtils.isObjectEmpty(c)) {
      this.loadMemberName(c);
    }
  };

  loadMemberName = (ids) => {
    let that = this;
    React.axios("/corp/list_member_name", {
      isUserOnly: !0,
      members: ids
        .filter((item) => item)
        .map((item) => (typeof item === "string" ? item : item._id || item.id)),
    })
      .then((res) => {
        BsyUtils.showAjaxTip(res.data, () => {
          let d = res.data;
          if (d.virtually && d.virtually.length > 0) {
            BsyUtils.forEach(d.virtually, function (k, z) {
              switch (z.mode) {
                case "role":
                  d.roles || (d.roles = []);
                  d.roles.push(z);
                  break;
                case "outsider":
                  d.outsiderMember || (d.outsiderMember = []);
                  d.outsiderMember.push(z);
                  break;
                case "member":
                  d.users || (d.users = []);
                  d.users.push(z);
                  break;
                case "outsiderGroup":
                  d.outsiderGroup || (d.outsiderGroup = []);
                  d.outsiderGroup.push(z);
                  break;
                case "current":
                case "currentSub":
                  d.job_title || (d.job_title = []);
                  d.job_title.push(z);
                  break;
                case "relationUser":
                  d.userRelation || (d.userRelation = []);
                  d.userRelation.push(z);
                  break;
                case "relationDept":
                  d.deptRelation || (d.deptRelation = []);
                  d.deptRelation.push(z);
                  break;
                case "deptSub":
                case "dept":
                  d.departments || (d.departments = []);
                  d.departments.push(z);
                  break;
                default:
                  break;
              }
            });
          }
          BsyUtils.forEach(d.users, function (a, d) {
            that.userValueMap[d._id] = BsyUtils._toDeptUser(d);
          });
          BsyUtils.forEach(d.outsiderMember, function (a, d) {
            that.userValueMap[d._id] = BsyUtils._toDeptUser(d);
          });
          BsyUtils.forEach(d.departments, function (a, d) {
            that.userValueMap[d._id] = BsyUtils._toDeptUser(d);
          });
          BsyUtils.forEach(d.dockuser, function (a, d) {
            that.userValueMap[d._id] = BsyUtils._toDeptUser(d);
          });
          this.setState({});
        });
      })
      .catch((res) => {
        console.error(res);
      });
  };

  showItem = () => {
    const { textField, valueField } = this.options;
    const { items, value } = this.state;
    let text = [];
    if (BsyUtils.isObjectEmpty(value)) {
      return text;
    }
    items &&
      items.map((val) => {
        if (BsyUtils.isObjectEmpty(value)) {
          if (val.selected)
            !BsyUtils.isObjectEmpty(val[valueField]) && (text = val[textField]);
        } else {
          if (val[valueField] === value)
            !BsyUtils.isObjectEmpty(val[valueField]) && (text = val[textField]);
        }
      });
    if (BsyUtils.isObjectEmpty(text)) {
      text = this.userValueMap[value];
    }
    return [text];
  };
}

export default BsyUserCheck;
